import round from 'lodash/round';

export const formatMinutes = (decimalTime: string): string => {
    const [minutes, minuteRemainder] = decimalTime.split('.');
    return `${minutes}m ${round(Number(`.${minuteRemainder}`) * 60)}s`;
};
